import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Localize } from '../../../../locale/localization';

const NavWrapper = styled.nav`
  position: absolute;
  border-radius: 5px;
  top:1rem;

  > ul {
    display: flex;
    flex-direction: column;
    white-space: nowrap;

    > li {
      padding: 0 1.25rem;

      > a {
        font-family: FyranSans-Core;
        color: white;
        display: block;
        padding-top: 0.5rem;
        padding-bottom: 1rem;
      }

      > ul {
        display: none;
        padding-top:1rem;
        > li {
          padding: 0;
          padding-bottom: 1rem;
        }
        > li a {
          color: white;
          font-family: FyranSans-Core;
          text-wrap:wrap;
          &.active {
            font-family: FyranSans-SemiBold;
            color:  #FF3334;
          }
        }
      }
    }

    li {
      line-height: 1.25rem;

      a {
        font-size: 1rem;
      }
    }
  }

  ${props =>
    props.isOpen &&
    `
    background: #1A2732;
    box-shadow: 1px 3px 10px 0 rgba(0,0,0,0.20);
    > ul > li > ul {
      display: block;
    }
  `};
`;

class SecondaryNavigation extends Component {
  state = {
    open: false,
  };

  componentDidMount = () => {
    document.addEventListener('click', this.close, true);
  };

  componentWillUnmount = () => {
    document.removeEventListener('click', this.close, true);
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.close();
    }
  };

  close = () => {
    this.setState({
      open: false,
    });
  };

  toggle = event => {
    event.stopPropagation();
    const { open } = this.state;
    this.setState({
      open: !open,
    });
  };

  onLogoutClick = event => {
    event.stopPropagation();
    this.props.onLogoutClick();
  };

  render() {
    const { currentUser } = this.props;
    const name = currentUser.firstName ? currentUser.firstName : Localize('navi.noname');

    return (
      <NavWrapper isOpen={this.state.open}>
        <ul>
          <li>
            <a onClick={this.toggle}>{name}</a>
            <ul>
              <li>
                <NavLink to="/profile">{Localize('navi.profile')}</NavLink>
              </li>
              <li>
                <a onClick={this.onLogoutClick}>{Localize('navi.logout')}</a>
              </li>
            </ul>
          </li>
        </ul>
      </NavWrapper>
    );
  }
}

export default withRouter(SecondaryNavigation);



// WEBPACK FOOTER //
// ./src/modules/common/components/app/SecondaryNavigation.js